import { Fragment, memo, useRef, useState } from 'react';
import { Button, Col, Form, Row } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import NoteDropdown from '../../noteDropdown';
import { useClickAway } from 'react-use';
import { lineHeightStyle, styledComponent, noteInline, isNoteUnderLine } from '../../../../../utils/helpers';
import CommonDeleteBtn from '../../commonDeleteBtn';
import SelectedItemSearch from '../selectedItemSearch';
import ChiefComplainDeleteBtn from '../../chiefComplainDeleteBtn';

const MedicalView = ({
  selectedHistories,
  setSelectedHistories,
  prescriptionItems,
  removeItemsData,
  isHistoryPage,
}) => {
  const allNotes = useSelector((state) => state?.prescriptionReducer?.prescriptionInfo?.itemElementNotes || []);
  const [isEdit, setIsEdit] = useState(null);

  const ref = useRef(null);
  useClickAway(ref, (e) => {
    setIsEdit(null);
  });

  const Title = styledComponent(
    prescriptionItems?.items?.['history']?.itemStyle || {},
  );
  const Value = styledComponent(
    prescriptionItems?.items?.['history']?.subItemStyle || {},
  );

  const medicalHistoriesExtra = (data) => {
    if (data?.duration) return ` - for ${data.duration} ${data.unit || ''}`;
    if (data?.unit === 'long time') return ` - for ${data.unit}`;
    return '';
  };

  const handleMedicalExtra = (item, fieldName, val) => {
    const medicalData = [...selectedHistories.medical];
    const objIndex = medicalData?.findIndex((data) => data.name === item.name);

    if (objIndex !== -1) {
      const updatedItem = { ...medicalData[objIndex] };
      if (fieldName === 'present' || fieldName === 'absent') {
        updatedItem.present = '';
        updatedItem.absent = '';
      } else if (fieldName === 'unit' && val === 'long time') {
        updatedItem.duration = '';
      }

      updatedItem[fieldName] = val;
      medicalData[objIndex] = updatedItem;

      setSelectedHistories({
        ...selectedHistories,
        medical: medicalData,
      });
    }
  };

  const clearHistoryInput = (index) => {
    selectedHistories.medical[index].present = '';
    selectedHistories.medical[index].absent = '';
    setSelectedHistories({ ...selectedHistories });
  };

  const removeMedicalHistory = (item) => {
    setSelectedHistories({
      ...selectedHistories,
      medical: selectedHistories?.medical.filter(
        (data) => data.name !== item.name,
      ),
    });
  };

  const editMode = (item) => {
    return (
      <Row ref={ref} className="selected-row-edit">
        <Col md={3} className="font-weight-bold pr-0 pl-0">
          {/* {item.name} */}
          <SelectedItemSearch
            apiUrl="medical-histories"
            selectedItemName={item.name}
            selectedItems={selectedHistories}
            selectedItemsAction={setSelectedHistories}
            medical={true}
          />
        </Col>
        <Col md={4} className="">
          <div className="d-flex">
            <Form.Check
              type="radio"
              id={`present`}
              label="Present"
              checked={item?.present === 'yes'}
              onChange={() => handleMedicalExtra(item, 'present', 'yes')}
            />
            <Form.Check
              type="radio"
              id={`absent`}
              label="Absent"
              className="ml-3"
              checked={item?.absent === 'no'}
              onChange={() => handleMedicalExtra(item, 'absent', 'no')}
            />
            <Button
              size="sm"
              className="ml-3"
              variant={item?.present || item?.absent ? 'primary' : 'light'}
              onClick={() => clearHistoryInput(item)}
            >
              Clear
            </Button>
          </div>
        </Col>
        <Col md={2} className="pl-0">
          <div className="input-group">
            <Form.Control
              size="sm"
              type="number"
              min="0"
              value={item?.duration || ''}
              onChange={(e) =>
                handleMedicalExtra(item, 'duration', e.target.value)
              }
            />
            <Form.Select
              className="form-control form-control-sm"
              value={item?.unit || ''}
              onChange={(e) => handleMedicalExtra(item, 'unit', e.target.value)}
            >
              <option value="day(s)">Day(s)</option>
              <option value="week(s)">Week(s)</option>
              <option value="month(s)">Month(s)</option>
              <option value="year(s)">Year(s)</option>
              <option value="long time">Long Time</option>
            </Form.Select>
          </div>
        </Col>
        <Col className="pl-0 pr-0">
          <div className="d-flex">
            <NoteDropdown
              value={item?.note || ''}
              onChange={(val) => handleMedicalExtra(item, 'note', val)}
              placeholder="Add Note"
              suggestions={allNotes.filter(
                (n) => n.elementType === 'history' && n.itemElement?.toLowerCase() === item?.name?.toLowerCase(),
              )}
            />

            <i
              className="far fa-times-circle pt-2 cursor-pointer"
              aria-hidden="true"
              onClick={() => setIsEdit(null)}
            ></i>
          </div>
        </Col>
      </Row>
    );
  };

  return (
    <>
      {/* <div className="his-sub-title">M/H</div> */}
      <ul style={lineHeightStyle('history', prescriptionItems)} key={`medical`}>
        {selectedHistories?.medical?.map((item, index) => (
          <Fragment>
            <li style={{ position: 'relative' }}>
              <div key={index} onClick={() => setIsEdit(index)}>
                <div key={index} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <span>
                    <Title>{item.name}</Title>
                    {item?.present === 'yes' && (
                      <span>
                        <Value>: Yes </Value>
                      </span>
                    )}
                    {item?.absent === 'no' && (
                      <span>
                        <Value>: No </Value>
                      </span>
                    )}
                    <Value>{medicalHistoriesExtra(item)}</Value>
                    {noteInline(item.note, 'history', prescriptionItems) && (
                      <Value>{noteInline(item.note, 'history', prescriptionItems)}</Value>
                    )}
                  </span>
                  {!isHistoryPage && (
                    <ChiefComplainDeleteBtn
                      action={removeItemsData}
                      itemName={'medical'}
                      delId={item.name}
                    />
                  )}
                </div>
                {item.note && isNoteUnderLine('history', prescriptionItems) && (
                  <div className="pl-2 preline">
                    <Value>{item?.note}</Value>
                  </div>
                )}
              </div>
              {index === isEdit && editMode(item)}
            </li>
          </Fragment>
        ))}
      </ul>
    </>
  );
};

export default memo(MedicalView);
